
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/date-pickers/date-time-picker-tabs",
      function () {
        return require("private-next-pages/x/api/date-pickers/date-time-picker-tabs.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/date-pickers/date-time-picker-tabs"])
      });
    }
  